/* src/app/builder-screen-beta/event-scripting/simple-mode/simple-mode.component.scss */
.simple-mode-container {
  padding: 16px;
}
.section {
  margin-bottom: 32px;
}
.section:last-child {
  margin-bottom: 0;
}
.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 600;
  color: #262626;
}
.section-title nz-icon {
  font-size: 18px;
  color: #1890ff;
}
/*# sourceMappingURL=simple-mode.component.css.map */
